import { api, loginapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const MaintenanceAPIs = {

    GetMaintenanceMode: async function (cancel = false){
        const response = await loginapi.request({
            url: '/maintenance-mode',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    
    PutMaintenanceMode: async function (putJSON, cancel = false){
        const response = await loginapi.request({
            url: '/maintenance-mode',
            method: 'PUT',
            data: putJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    

    
}
const cancelAPIObject = defineCancelApiObject(MaintenanceAPIs)